import * as categorize from "./categorize-data";

import { FileLoaded, Transaction } from "../data-types";
import {
  changeDateOrder,
  convertExcelDate,
  stringToTimestamp,
} from "../util/date-util";

const amex = (rawData: any[], fileLoaded: FileLoaded) => {
  const data: Transaction[] = [];
  // const accountNumber: string = rawData[4][0];
  rawData.splice(0, 7);
  rawData.forEach((element: any) => {
    const desc = element[1];
    const amount = element[2];
    const defaultCat = element[element.length - 1];

    const categoryBCJL = categorize.categorizeTransaction(
      desc.toUpperCase(),
      defaultCat.toUpperCase(),
      amount
    );

    const category = categoryBCJL[0];
    const BCJL = categoryBCJL[1];
    const bank = "Amex BC";
    const fullDate = stringToTimestamp(changeDateOrder(element[0]));
    const year = Number(changeDateOrder(element[0]).split("/")[0]);
    const month = Number(changeDateOrder(element[0]).split("/")[1]);
    const date = Number(changeDateOrder(element[0]).split("/")[2]);
    const createdAt = fileLoaded.createdAt;
    data.push({
      fullDate,
      year,
      month,
      date,
      desc,
      amount,
      category,
      bank,
      BCJL,
      createdAt,
    });
  });
  return data;
};

const chase = (rawData: object[], fileLoaded: FileLoaded) => {
  const data: Transaction[] = [];

  rawData.splice(0, 1);

  rawData.forEach((element: any) => {
    const strElement = new String(element[0]);
    const isDebit = isNaN(Number(strElement.charAt(0)));
    // const is3225 = fileLoaded.file.name.includes("3225")
    const bank = !isDebit
      ? "Chase Credit BC"
      : fileLoaded.file.name.includes("6609")
      ? "Chase Debit JL"
      : "Chase Debit BC";
    const extension = fileLoaded.file.name.split(".")[1].toUpperCase();
    const convertedDate = extension.includes("CSV")
      ? convertExcelDate(element[1])
      : extension.includes("XLSX")
      ? changeDateOrder(element[1])
      : "";
    const fullDate = stringToTimestamp(convertedDate);
    const desc = element[2];
    const amount =
      bank === "Chase Credit BC" ? -Number(element[5]) : -Number(element[3]);

    const defaultCat: string =
      bank === "Chase Credit BC" && element[3] ? element[3] : "Unknown";
    // const categoryBCJL: string[] =
    //   bank === "Chase Credit BC"
    //     ? categorize.chaseCredit(
    //         desc.toUpperCase(),
    //         amount,
    //         defaultCat.toUpperCase()
    //       )
    //     : categorize.chaseDebit(desc.toUpperCase());
    const categoryBCJL: string[] =
      bank === "Chase Credit BC"
        ? categorize.categorizeTransaction(
            desc.toUpperCase(),
            defaultCat.toUpperCase(),
            amount
          )
        : categorize.categorizeTransaction(desc.toUpperCase(), "", 0);
    // const category =
    //   categoryBCJL[0] === "Not Include" && bank.includes("BC")
    //     ? "Not Include BC"
    //     : categoryBCJL[0] === "Not Include" && bank.includes("JL")
    //     ? "Not Include JL"
    //     : categoryBCJL[0];
    const category = categoryBCJL[0] || "Unknown";
    const year = Number(convertedDate.split("/")[0]);
    const month = Number(convertedDate.split("/")[1]);
    const date = Number(convertedDate.split("/")[2]);
    // const BCJL = categoryBCJL[1] || "Unknown";
    const BCJL =
      categoryBCJL[1] === "Not Include" && bank.includes("BC")
        ? "Not Include BC"
        : categoryBCJL[1] === "Not Include" && bank.includes("JL")
        ? "Not Include JL"
        : categoryBCJL[1];
    const createdAt = fileLoaded.createdAt;
    data.push({
      fullDate,
      desc,
      amount,
      category,
      bank,
      year,
      month,
      date,
      BCJL,
      createdAt,
    });
  });
  console.log(data);
  return data;
};

const discover = (rawData: object[], fileLoaded: FileLoaded) => {
  const data: Transaction[] = [];
  rawData.splice(0, 1);
  rawData.forEach((element: any) => {
    const extension = fileLoaded.file.name.split(".")[1].toUpperCase();
    const convertedDate = extension.includes("CSV")
      ? convertExcelDate(element[1])
      : extension.includes("XLSX")
      ? changeDateOrder(element[1])
      : "";
    const fullDate = stringToTimestamp(convertedDate);
    const defaultCat = element[4];
    const desc = element[2];
    const amount = Number(element[3]);
    // const categoryBCJL = categorize.discover(
    //   desc.toUpperCase(),
    //   defaultCat.toUpperCase()
    // );
    const categoryBCJL = categorize.categorizeTransaction(
      desc.toUpperCase(),
      defaultCat.toUpperCase(),
      0
    );
    const category = categoryBCJL[0];
    const BCJL = categoryBCJL[1];
    const bank = "Discover BC";
    const year = Number(convertedDate.split("/")[0]);
    const month = Number(convertedDate.split("/")[1]);
    const date = Number(convertedDate.split("/")[2]);
    const createdAt = fileLoaded.createdAt;
    data.push({
      fullDate,
      desc,
      amount,
      category,
      bank,
      year,
      month,
      date,
      BCJL,
      createdAt,
    });
  });
  return data;
};

export { amex, chase, discover };
